import propertyDetailsReducer from "./propertyDetailsReducer";

export * from "./propertyDetailsReducer";

export default propertyDetailsReducer;
